module.exports = __webpack_public_path__ + "img/Landing-page-img.ce787c81.jpeg";